// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import Label from "../../ui/Label";
import { ENUMS } from "../../utils/Enums";
import { showCategorySelector } from "../../utils/Utils";
import Bisacs from "../../popovers/Bisacs";
import { ROUTES } from "../../utils/Routes";
import { createModal } from "../../hooks/createModal";
import { getValue } from "@testing-library/user-event/dist/utils";

export default function SelectBisac(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, inputParams = {}, edit = false, category = false, subcategory = false } = props;

    const { value = 1, type = "" } = filter;

    let text = filter.text;
    let text2 = filter.text2;
    let instructions = filter.instructions;
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false;

    if (_data) {
        text = _data.text;
    }


    const fields = [
        { key: "value_1", value: (edit) ? filter.value_1 : "", help:  "Enter a value or PgUp to select" },
        { label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const value_1 = tabs.find(f => f.key === "value_1").value;
        const _f = {
            ...FILTER,
            type: value,
            value_1: value_1.toString()
        }
        onSave(_f, filter);
    }


    const selectBisac = (_search, callback = () => { }) => {
        let _ret = window.bm_state.value;
        window.bm_state.value = ROUTES.HELPERS.BISACS;
        createModal({
            offset: [0, -330],
            component: <Bisacs controller={controller} modal={true} value={_search} route={ROUTES.HELPERS.BISACS} />, title: "Select Bisac", closable: true, callback: (e) => {
                if (e) {
                    callback(e)
                }
                window.bm_state.value = _ret;
            }
        })

    }

    return (
        <FilterBase controller={controller} fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs, filter)
        }}>
            {({ editProps, update, tabs, proceed, setIndex, getVal, index, refs }) => (
                <div>
                    <Space>
                        <span>{text}</span>

                        <Input onPageUp={() => {
                            refs.current["value_1"].blur();
                            selectBisac(getVal("value_1"), (e) => {
                                refs.current["value_1"].focus();
                                update("value_1", e);
                            })

                        }} doubleclick={() => {
                             refs.current["value_1"].blur();
                             selectBisac(getVal("value_1"), (e) => {
                                refs.current["value_1"].focus();
                                update("value_1", e);
                            })
                        }} {...editProps("value_1")} {...inputParams} onFill={(e) => proceed(e)} />
                        {(text2 && <span>{text2}</span>)}
                        <Button onClick={() => save(tabs)} {...editProps("save")}>Save</Button>
                    </Space>
                    {(instructions && <Label style={{ "textAlign": "left" }}>{instructions}</Label>)}
                </div>
            )}
        </FilterBase>
    );
}
